import Vue from 'vue'

import ProBadge from '@/components/ProBadge'
import LoadingIndicator from '@/components/LoadingIndicator'
import HelpLink from '@/components/HelpLink'

Vue.component('ProBadge', ProBadge)
Vue.component('Spinner', LoadingIndicator)
Vue.component('HelpLink', HelpLink)
